import { render, staticRenderFns } from "./FilterText.vue?vue&type=template&id=2f643b37&"
import script from "./FilterText.vue?vue&type=script&lang=js&"
export * from "./FilterText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f643b37')) {
      api.createRecord('2f643b37', component.options)
    } else {
      api.reload('2f643b37', component.options)
    }
    module.hot.accept("./FilterText.vue?vue&type=template&id=2f643b37&", function () {
      api.rerender('2f643b37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Filter/FilterText.vue"
export default component.exports